import { Outlet } from 'react-router-dom';
import GlobalErrorsModal from '@jobcost-monorepo/crud/ui/GlobalErrorsModal';
import React from 'react';
import SidebarLayout from '../SidebarLayout';

export default function Layout() {
  return (
    <div className="flex text-black dark:text-white bg-white dark:bg-dark overflow-hidden">
      <SidebarLayout>
        <Outlet />
      </SidebarLayout>
      <GlobalErrorsModal />
    </div>
  );
}
